module.exports = __webpack_public_path__ + "img/signature_red.574346c5.png";